import React, {useState} from 'react';
import {Button, Form} from 'react-bootstrap'
import Tabella from '../Tabella';

function TabellaCollassabile (props) {
    const [width, setWidth] = useState('100%');

    const handlerChange = () => {
        props.setOpen(!props.open)
        props.setLarghezza()
        if (!props.type.startsWith("riepilogo")) {
            setWidth('613%')
        }
	};

    const isRiepilogoTotale = props.type === "riepilogototale";
    const currentRows = (isRiepilogoTotale && props.visualizzaCristallizzati) ? props.rowsCristallizzato : props.rows;
    const currentButton = (isRiepilogoTotale && props.visualizzaCristallizzati) ? props.buttonCristallizzato : props.button;

    if (props.open) {
        var downloadbutton = <div className="buttonDownloadCampagna" key={props.button}>{currentButton}</div>
    }
    
    // Costruiamo l'id univoco del checkbox basato sul nome della tabella (es: "2026 Riepilogo totale checkbox_cristallizzati")
    const chkId = (props.nomeTabella + "_checkbox_cristallizzati").replace(/\s+/g, '_');

    return(
        <div className="tabella col">
            <div className="row" style={{width: `${width}`}}>
                <div className="divDropdownbutton ml-3 d-flex align-items-center">
                    <Button onClick={handlerChange} className="dropdown-toggle btnGenerale" id={props.nomeTabella}
                        variant="" size='sm' 
                        aria-controls="espandere tabella" aria-expanded={props.open} key={props.nomeTabella}>{props.nomeTabella}
                    </Button>
                    {isRiepilogoTotale && (
                        <div className="ml-3 d-flex align-items-center">
                            <Form.Check
                                type="checkbox"
                                id={chkId}
                                label="Dati cristallizzati"
                                checked={props.visualizzaCristallizzati}
                                onChange={(e) => props.setVisualizzaCristallizzati(e.target.checked)}
                            />
                        </div>
                    )}
                </div>
                {downloadbutton}
            </div>
            <Tabella rows={currentRows} 
                intestazione={props.intestazione} 
                open={props.open} 
                numeri730 = {props.numeri730}
                numeriIsee = {props.numeriIsee}
                nomeTabella={props.nomeTabella}
                isRiepilogoTotale={isRiepilogoTotale}/>
    </div>
    )
}

export default TabellaCollassabile;